import toast from "react-hot-toast";

import { PortfolioDataItem } from "@/types/types";

export const getPortfolioSlug = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getPortfolioMediaSlug = (src: string) => {
  const filename = src.split("/").pop()?.split("?")[0] || "media";
  return getPortfolioSlug(filename.replace(/\.[^.]+$/, ""));
};

export const getPortfolioBrandPath = (group: PortfolioDataItem) =>
  `/portfolio/${group.type}/${getPortfolioSlug(group.brand)}`;

export const getPortfolioCategoryPath = (
  type: PortfolioDataItem["type"],
  category: string,
) => `/portfolio/${type}?category=${getPortfolioSlug(category)}`;

export const getPortfolioMediaPath = (
  group: PortfolioDataItem,
  mediaIndex: number,
) =>
  `${getPortfolioBrandPath(group)}/${getPortfolioMediaSlug(group.media[mediaIndex])}`;

export const sharePortfolioPath = async (title: string, path: string) => {
  const url = new URL(path, window.location.origin).toString();

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") return;
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    toast.success("Share link copied");
  } catch {
    toast.error("Unable to copy share link");
  }
};
